import bulkItems from './bulkItems';
import prepareBulkDelete from './prepareBulkDelete';
import prepareReasign from './prepareReasign';

export default (ids, value, filterData = {}, callback = null) =>
    (dispatch) => {
        switch (value) {
            case 'deleted':
                dispatch(prepareBulkDelete(ids, value, filterData, callback));
                break;
            case 'reasign_user':
                dispatch(prepareReasign(ids, callback));
                break;
            default:
                dispatch(bulkItems(ids, value, filterData, callback));
                break;
        }
    };
